import { Component, OnInit, inject, signal } from '@angular/core';
import {
  TenantPlanApiService,
  WorkspaceUsage,
} from '../../shared/services/tenant-plan-api.service';
import { TenantService } from '../../shared/services/tenant.service';

@Component({
  selector: 'black-workspace-usage',
  templateUrl: './workspace-usage.component.html',
  styleUrls: ['./workspace-usage.component.css'],
  standalone: false,
})
export class WorkspaceUsageComponent implements OnInit {
  private tenantPlanApi = inject(TenantPlanApiService);
  private tenantService = inject(TenantService);

  usageData = signal<WorkspaceUsage | null>(null);
  loading = signal<boolean>(true);
  error = signal<string | null>(null);

  get currentTenant() {
    return this.tenantService.currentTenant;
  }

  ngOnInit(): void {
    this.loadUsage();
  }

  loadUsage(): void {
    this.loading.set(true);
    this.error.set(null);

    this.tenantPlanApi.getWorkspaceUsage().subscribe({
      next: (data) => {
        this.usageData.set(data);
        this.loading.set(false);
      },
      error: (err) => {
        this.error.set(
          err?.error?.message || 'Failed to load workspace usage metrics.',
        );
        this.loading.set(false);
      },
    });
  }

  getProgressColorClass(percent: number): string {
    if (percent >= 100) return 'daisy-progress-error';
    if (percent >= 80) return 'daisy-progress-warning';
    return 'daisy-progress-primary';
  }

  getBadgeColorClass(percent: number): string {
    if (percent >= 100) return 'daisy-badge-error';
    if (percent >= 80) return 'daisy-badge-warning';
    return 'daisy-badge-success';
  }
}
